import { useLoggedGeladaLazyQuery } from '@netfront/gelada-identity-library';

import { GET_UNITS_BY_GROUP } from './useGetUnitsByGroup.graphql';
import {
  IGetUnitsByGroupQueryGraphQLResponse,
  IGetUnitsByGroupQueryVariables,
  IHandleGetUnitsByGroupParams,
  IUseGetUnitsByGroup,
  IUseGetUnitsByGroupOptions,
} from './useGetUnitsByGroup.interfaces';

const useGetUnitsByGroup = (options?: IUseGetUnitsByGroupOptions): IUseGetUnitsByGroup => {
  const { fetchPolicy, onCompleted, onError, query, tokens } = options ?? ({} as IUseGetUnitsByGroupOptions);

  const [executeGetUnitsByGroup, { loading: isLoading }] = useLoggedGeladaLazyQuery<
    IGetUnitsByGroupQueryGraphQLResponse,
    IGetUnitsByGroupQueryVariables
  >({
    options: {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: ({ unit: { getByGroup }}) => {
        if (!onCompleted) {
          return;
        }

        onCompleted({
          units: getByGroup
        });
      },
      onError,
    },
    query: query ?? GET_UNITS_BY_GROUP,
    tokens,
  });


  const handleGetUnitsByGroup = async ({
    groupId
  }: IHandleGetUnitsByGroupParams) => {
    await executeGetUnitsByGroup({
      variables: {
        groupId,
      },
    });
  };

  return {
    handleGetUnitsByGroup,
    isLoading,
  };
};

export { useGetUnitsByGroup };
